module.exports = __webpack_public_path__ + "static/media/integration.b5a92e9a.jpg";